webpackJsonp([6],{

/***/ "5/M7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ./components/tabs/index.js
var tabs = __webpack_require__("ki89");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./utils/formatters.js
var utils_formatters = __webpack_require__("gNwm");

// EXTERNAL MODULE: ./utils/convert-wind-bearing.js
var convert_wind_bearing = __webpack_require__("Dqzv");

// EXTERNAL MODULE: ./components/records-table/style.scss
var style = __webpack_require__("wzQq");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/records-table/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The RecordsTable component displays a responsive table of weather records.
 *
 * props:
 * - data: records data set
 * - isMonthly: is this a monthly records set (will only contain a subset of the full records)
 */

var _ref = Object(preact_min["h"])(
	'span',
	null,
	'Most consecutive wet days (\u22651 mm)'
);

var _ref2 = Object(preact_min["h"])(
	'span',
	null,
	'Most consecutive non-wet days (<1 mm)'
);

var _ref3 = Object(preact_min["h"])('br', null);

var records_table_RecordsTable = function (_Component) {
	_inherits(RecordsTable, _Component);

	function RecordsTable(props, context) {
		_classCallCheck(this, RecordsTable);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.units = context.userSettings.units;

		_this.formatters = {
			date: Object(utils_formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d', '%-d %b %Y'),
			time: Object(utils_formatters["j" /* getDateTimeFormatConverter */])('%H:%M:%S', '%-I:%M %p'),
			temperature: function temperature(t) {
				return Object(utils_formatters["f" /* formatTemperature */])(t, _this.units.temperature) + '°' + _this.units.temperature;
			},
			temperatureInterval: function temperatureInterval(t) {
				return Object(utils_formatters["g" /* formatTemperatureInterval */])(t, _this.units.temperature) + '°' + _this.units.temperature;
			},
			rainfall: function rainfall(r) {
				return Object(utils_formatters["e" /* formatRainfall */])(r, _this.units.rain) + ' ' + _this.units.rain;
			},
			rainRate: function rainRate(r) {
				return Object(utils_formatters["d" /* formatRainRate */])(r, _this.units.rain) + ' ' + _this.units.rain + '/hr';
			},
			pressure: function pressure(p) {
				return Object(utils_formatters["c" /* formatPressure */])(p, _this.units.pressure) + ' ' + _this.units.pressure;
			},
			windGust: function windGust(w) {
				return Object(utils_formatters["h" /* formatWindGust */])(w, _this.units.speed) + ' ' + _this.units.speed;
			},
			windRun: function windRun(w) {
				return Object(utils_formatters["i" /* formatWindSpeed */])(w, _this.units.speed) + ' ' + Object(utils_formatters["a" /* convertSpeedUnitToWindRunUnit */])(_this.units.speed);
			}
		};

		return _this;
	}

	RecordsTable.prototype.renderTable = function renderTable(data) {
		return Object(preact_min["h"])(
			'div',
			{ role: 'table', 'class': style_default.a.records_table },
			Object(preact_min["h"])(
				'div',
				{ role: 'rowgroup', 'class': style_default.a.column_headings },
				Object(preact_min["h"])(
					'div',
					{ role: 'row', 'class': style_default.a.row },
					Object(preact_min["h"])(
						'div',
						{ role: 'columnheader', 'class': style_default.a.label_cell },
						'Record'
					),
					Object(preact_min["h"])(
						'div',
						{ role: 'columnheader', 'class': style_default.a.value_cell },
						'Value'
					),
					Object(preact_min["h"])(
						'div',
						{ role: 'columnheader', 'class': style_default.a.datetime_cell },
						'Date/Time'
					)
				)
			),
			Object(preact_min["h"])(
				'div',
				{ role: 'rowgroup' },
				this.renderRow('Highest temperature', this.formatters.temperature(data.highest_HighTemperature.highTemperature), data.highest_HighTemperature.date, data.highest_HighTemperature.highTemperatureTime),
				this.renderRow('Lowest temperature', this.formatters.temperature(data.lowest_LowTemperature.lowTemperature), data.lowest_LowTemperature.date, data.lowest_LowTemperature.lowTemperatureTime),
				this.renderRow('Lowest daily maximum', this.formatters.temperature(data.lowest_HighTemperature.highTemperature), data.lowest_HighTemperature.date, data.lowest_HighTemperature.highTemperatureTime),
				this.renderRow('Highest daily minimum', this.formatters.temperature(data.highest_LowTemperature.lowTemperature), data.highest_LowTemperature.date, data.highest_LowTemperature.lowTemperatureTime),
				this.renderRow('Overall warmest day', this.formatters.temperature(data.highest_MeanTemperature.avgTemperature), data.highest_MeanTemperature.date, null),
				this.renderRow('Overall coolest day', this.formatters.temperature(data.lowest_MeanTemperature.avgTemperature), data.lowest_MeanTemperature.date, null),
				this.renderRow('Largest temperature range', this.formatters.temperatureInterval(data.largest_TemperatureRange.temperatureRange), data.largest_TemperatureRange.date, null),
				this.renderRow('Smallest temperature range', this.formatters.temperatureInterval(data.smallest_TemperatureRange.temperatureRange), data.smallest_TemperatureRange.date, null),
				this.renderRow('Highest daily rainfall', this.formatters.rainfall(data.highest_Rainfall.rainfall), data.highest_Rainfall.date, null),
				this.renderRow('Highest 1 hour rainfall', this.formatters.rainfall(data.highest_HighHourlyRain.highHourlyRain), data.highest_HighHourlyRain.date, data.highest_HighHourlyRain.highHourlyRainTime),
				this.renderRow('Highest rain rate', this.formatters.rainRate(data.highest_HighRainRate.highRainRate), data.highest_HighRainRate.date, data.highest_HighRainRate.highRainRateTime),
				this.renderRow('Highest wind gust', Object(convert_wind_bearing["a" /* convertWindBearing16 */])(data.highest_HighWindGust.highWindGustBearing) + ' ' + this.formatters.windGust(data.highest_HighWindGust.highWindGust), data.highest_HighWindGust.date, data.highest_HighWindGust.highWindGustTime),
				this.renderRow('Highest wind run', this.formatters.windRun(data.highest_WindRun.windRun), data.highest_WindRun.date, null),
				this.renderRow('Highest pressure', this.formatters.pressure(data.highest_HighPressure.highPressure), data.highest_HighPressure.date, data.highest_HighPressure.highPressureTime),
				this.renderRow('Lowest pressure', this.formatters.pressure(data.lowest_LowPressure.lowPressure), data.lowest_LowPressure.date, data.lowest_LowPressure.lowPressureTime),
				this.renderRow('Highest dewpoint', this.formatters.temperature(data.highest_HighDewpoint.highDewpoint), data.highest_HighDewpoint.date, data.highest_HighDewpoint.highDewpointTime),
				this.renderRow('Lowest dewpoint', this.formatters.temperature(data.lowest_LowDewpoint.lowDewpoint), data.lowest_LowDewpoint.date, data.lowest_LowDewpoint.lowDewpointTime),
				this.renderRow('Lowest humidity', data.lowest_LowHumidity.lowHumidity + '%', data.lowest_LowHumidity.date, data.lowest_LowHumidity.lowHumidityTime),
				this.props.isMonthly ? null : this.renderExtraRecords(data)
			)
		);
	};

	RecordsTable.prototype.renderExtraRecords = function renderExtraRecords(data) {
		return [this.renderRow('Highest 7 day rainfall', this.formatters.rainfall(data.highest_Rainfall7days.rainfall), [data.highest_Rainfall7days.startDate, data.highest_Rainfall7days.endDate], null), this.renderRow('Highest 30 day rainfall', this.formatters.rainfall(data.highest_Rainfall30days.rainfall), [data.highest_Rainfall30days.startDate, data.highest_Rainfall30days.endDate], null), this.renderRow('Highest 60 day rainfall', this.formatters.rainfall(data.highest_Rainfall60days.rainfall), [data.highest_Rainfall60days.startDate, data.highest_Rainfall60days.endDate], null), this.renderRow('Highest 90 day rainfall', this.formatters.rainfall(data.highest_Rainfall90days.rainfall), [data.highest_Rainfall90days.startDate, data.highest_Rainfall90days.endDate], null), this.renderRow('Highest 365 day rainfall', this.formatters.rainfall(data.highest_Rainfall365days.rainfall), [data.highest_Rainfall365days.startDate, data.highest_Rainfall365days.endDate], null), this.renderRow('Lowest 30 day rainfall', this.formatters.rainfall(data.lowest_Rainfall30days.rainfall), [data.lowest_Rainfall30days.startDate, data.lowest_Rainfall30days.endDate], null), this.renderRow('Lowest 60 day rainfall', this.formatters.rainfall(data.lowest_Rainfall60days.rainfall), [data.lowest_Rainfall60days.startDate, data.lowest_Rainfall60days.endDate], null), this.renderRow('Lowest 90 day rainfall', this.formatters.rainfall(data.lowest_Rainfall90days.rainfall), [data.lowest_Rainfall90days.startDate, data.lowest_Rainfall90days.endDate], null), this.renderRow('Lowest 365 day rainfall', this.formatters.rainfall(data.lowest_Rainfall365days.rainfall), [data.lowest_Rainfall365days.startDate, data.lowest_Rainfall365days.endDate], null), this.renderRow(_ref, data.longest_PeriodWetDays.days, [data.longest_PeriodWetDays.startDate, data.longest_PeriodWetDays.endDate], null), this.renderRow(_ref2, data.longest_PeriodNoWetDays.days, [data.longest_PeriodNoWetDays.startDate, data.longest_PeriodNoWetDays.endDate], null), this.renderRow('Most consecutive days with 0.0mm', data.longest_PeriodNoRainfall.days, [data.longest_PeriodNoRainfall.startDate, data.longest_PeriodNoRainfall.endDate], null)];
	};

	RecordsTable.prototype.renderRow = function renderRow(label, value, date, time) {
		var _this2 = this;

		var dates = Array.isArray(date) ? date : [date];

		return Object(preact_min["h"])(
			'div',
			{ role: 'row', 'class': style_default.a.row },
			Object(preact_min["h"])(
				'div',
				{ role: 'rowheader', 'class': style_default.a.label_cell },
				label
			),
			Object(preact_min["h"])(
				'div',
				{ role: 'cell', 'class': style_default.a.value_cell },
				value
			),
			Object(preact_min["h"])(
				'div',
				{ role: 'cell', 'class': style_default.a.datetime_cell },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.date },
					dates.map(function (d, i) {
						return [i > 0 ? ' to' : null, i > 0 ? _ref3 : null, Object(preact_min["h"])(
							match["Link"],
							{ href: '/history-daily/' + d },
							_this2.formatters.date(d)
						)];
					})
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.time },
					time ? this.formatters.time(time) : null
				)
			)
		);
	};

	RecordsTable.prototype.render = function render(props) {
		return Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.records_table },
			this.renderTable(props.data)
		);
	};

	return RecordsTable;
}(preact_min["Component"]);

/* harmony default export */ var records_table = (records_table_RecordsTable);
// EXTERNAL MODULE: ./components/handle-loading-and-error/index.js + 1 modules
var handle_loading_and_error = __webpack_require__("/zgt");

// CONCATENATED MODULE: ./components/records-overall/index.js




var records_overall_RecordsOverall = function RecordsOverall(props) {
	return Object(preact_min["h"])(records_table, { data: props.data, isMonthly: false });
};

/* harmony default export */ var records_overall = (Object(handle_loading_and_error["a" /* default */])(records_overall_RecordsOverall));
// EXTERNAL MODULE: ./components/size-aware/index.js
var size_aware = __webpack_require__("ZnYl");

// EXTERNAL MODULE: ./components/selector/index.js
var selector = __webpack_require__("l44Q");

// EXTERNAL MODULE: ./components/records-top-ten/style.scss
var records_top_ten_style = __webpack_require__("g7QX");
var records_top_ten_style_default = /*#__PURE__*/__webpack_require__.n(records_top_ten_style);

// CONCATENATED MODULE: ./components/records-top-ten/parameters-data.js



function getParametersData(parameterIds, units, formatters) {
	return [{
		id: parameterIds.HIGHEST_HIGH_TEMPERATURE,
		field: 'highTemperature',
		unit: '°' + units.temperature,
		formatter: formatters.temperature,
		label: 'Highest temperatures',
		description: 'Highest daily maximum temperatures.'
	}, {
		id: parameterIds.LOWEST_LOW_TEMPERATURE,
		field: 'lowTemperature',
		unit: '°' + units.temperature,
		formatter: formatters.temperature,
		label: 'Lowest temperatures',
		description: 'Lowest daily minimum temperatures.'
	}, {
		id: parameterIds.HIGHEST_MEAN_TEMPERATURE,
		field: 'avgTemperature',
		unit: '°' + units.temperature,
		formatter: formatters.temperature,
		label: 'Warmest days',
		description: 'Highest daily mean temperatures. This is the average of all temperature observations during a day, taken every 1 minute.'
	}, {
		id: parameterIds.LOWEST_MEAN_TEMPERATURE,
		field: 'avgTemperature',
		unit: '°' + units.temperature,
		formatter: formatters.temperature,
		label: 'Coolest days',
		description: 'Lowest daily mean temperatures. This is the average of all temperature observations during a day, taken every 1 minute.'
	}, {
		id: parameterIds.LOWEST_HIGH_TEMPERATURE,
		field: 'highTemperature',
		unit: '°' + units.temperature,
		formatter: formatters.temperature,
		label: 'Lowest daily highs',
		description: 'Lowest daily maximum temperatures.'
	}, {
		id: parameterIds.HIGHEST_LOW_TEMPERATURE,
		field: 'lowTemperature',
		unit: '°' + units.temperature,
		formatter: formatters.temperature,
		label: 'Highest daily lows',
		description: 'Highest daily minimum temperatures.'
	}, {
		id: parameterIds.LARGEST_TEMPERATURE_RANGE,
		field: 'temperatureRange',
		unit: '°' + units.temperature,
		formatter: formatters.temperatureInterval,
		label: 'Largest daily ranges',
		description: 'Largest daily temperature ranges.'
	}, {
		id: parameterIds.SMALLEST_TEMPERATURE_RANGE,
		field: 'temperatureRange',
		unit: '°' + units.temperature,
		formatter: formatters.temperatureInterval,
		label: 'Smallest daily ranges',
		description: 'Smallest daily temperature ranges.'
	}, {
		id: parameterIds.HIGHEST_RAINFALL,
		field: 'rainfall',
		unit: units.rain,
		formatter: formatters.rainfall,
		label: 'Wettest days',
		description: 'Highest daily rainfall totals.'
	}, {
		id: parameterIds.HIGHEST_HOURLY_RAINFALL,
		field: 'highHourlyRain',
		unit: units.rain,
		formatter: formatters.rainfall,
		label: 'Highest hourly rainfall',
		description: 'Highest 1 hour rainfall totals. Note that the list may contain two entries for a single rain event if the event occurs close to midnight.'
	}, {
		id: parameterIds.HIGHEST_RAIN_RATE,
		field: 'highRainRate',
		unit: units.rain + '/hr',
		formatter: formatters.rainRate,
		label: 'Highest rain rates',
		description: 'Highest instantaneous rainfall rates.'
	}, {
		id: parameterIds.HIGHEST_WIND_GUST,
		field: 'highWindGust',
		additionalColumns: [{
			field: 'highWindGustBearing',
			label: 'Direction',
			formatter: function formatter(b) {
				return Object(convert_wind_bearing["a" /* convertWindBearing16 */])(b);
			}
		}],
		unit: units.speed,
		formatter: formatters.windGust,
		label: 'Highest wind gusts',
		description: 'Highest wind gusts.'
	}, {
		id: parameterIds.HIGHEST_WIND_RUN,
		field: 'windRun',
		unit: Object(utils_formatters["a" /* convertSpeedUnitToWindRunUnit */])(units.speed),
		formatter: formatters.windRun,
		label: 'Highest wind runs',
		description: 'Highest daily wind runs. Think of wind run as the distance the wind would have travelled over the course of a day. It gives a measure of overall windiness.'
	}, {
		id: parameterIds.HIGHEST_PRESSURE,
		field: 'highPressure',
		unit: units.pressure,
		formatter: formatters.pressure,
		label: 'Highest pressures',
		description: 'Highest atmospheric pressure readings.'
	}, {
		id: parameterIds.LOWEST_PRESSURE,
		field: 'lowPressure',
		unit: units.pressure,
		formatter: formatters.pressure,
		label: 'Lowest pressures',
		description: 'Lowest atmospheric pressure readings.'
	}, {
		id: parameterIds.HIGHEST_DEWPOINT,
		field: 'highDewpoint',
		unit: '°' + units.temperature,
		formatter: formatters.temperature,
		label: 'Highest dewpoints',
		description: 'Highest daily maximum dewpoints.'
	}, {
		id: parameterIds.LOWEST_DEWPOINT,
		field: 'lowDewpoint',
		unit: '°' + units.temperature,
		formatter: formatters.temperature,
		label: 'Lowest dewpoints',
		description: 'Lowest daily minimum dewpoints.'
	}, {
		id: parameterIds.LOWEST_HUMIDITY,
		field: 'lowHumidity',
		unit: '%',
		formatter: function formatter(h) {
			return h;
		},
		label: 'Lowest humidity',
		description: 'Lowest daily minimum humidity readings.'
	}];
}
// CONCATENATED MODULE: ./components/records-top-ten/index.js


function records_top_ten__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function records_top_ten__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function records_top_ten__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 * The RecordsTopTen component is a view available for display on the History Records page.
 * It displays a list of parameters to choose from, and will display a table of the top
 * 10 records for that parameter ranked from 1st to 10th.
 *
 * props:
 * - data: full top10 records data set
 */

var records_top_ten__ref = Object(preact_min["h"])(
	'div',
	{ role: 'columnheader' },
	'Rank'
);

var records_top_ten__ref2 = Object(preact_min["h"])(
	'div',
	{ role: 'columnheader' },
	'Date'
);

var records_top_ten_RecordsTopTen = function (_Component) {
	records_top_ten__inherits(RecordsTopTen, _Component);

	function RecordsTopTen(props, context) {
		records_top_ten__classCallCheck(this, RecordsTopTen);

		var _this = records_top_ten__possibleConstructorReturn(this, _Component.call(this, props, context));

		var units = context.userSettings.units;


		_this.formatters = {
			date: Object(utils_formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d', '%-d %b %Y'),
			time: Object(utils_formatters["j" /* getDateTimeFormatConverter */])('%H:%M:%S', '%-I:%M %p'),
			temperature: function temperature(t) {
				return Object(utils_formatters["f" /* formatTemperature */])(t, units.temperature);
			},
			temperatureInterval: function temperatureInterval(t) {
				return Object(utils_formatters["g" /* formatTemperatureInterval */])(t, units.temperature) + '°' + units.temperature;
			},
			rainfall: function rainfall(r) {
				return Object(utils_formatters["e" /* formatRainfall */])(r, units.rain);
			},
			rainRate: function rainRate(r) {
				return Object(utils_formatters["d" /* formatRainRate */])(r, units.rain);
			},
			pressure: function pressure(p) {
				return Object(utils_formatters["c" /* formatPressure */])(p, units.pressure);
			},
			windGust: function windGust(w) {
				return Object(utils_formatters["h" /* formatWindGust */])(w, units.speed);
			},
			windRun: function windRun(w) {
				return Object(utils_formatters["i" /* formatWindSpeed */])(w, units.speed);
			}
		};

		_this.PARAMETER_ID = {
			HIGHEST_HIGH_TEMPERATURE: 'highest_HighTemperature',
			LOWEST_HIGH_TEMPERATURE: 'lowest_HighTemperature',
			LOWEST_LOW_TEMPERATURE: 'lowest_LowTemperature',
			HIGHEST_LOW_TEMPERATURE: 'highest_LowTemperature',
			HIGHEST_MEAN_TEMPERATURE: 'highest_MeanTemperature',
			LOWEST_MEAN_TEMPERATURE: 'lowest_MeanTemperature',
			LARGEST_TEMPERATURE_RANGE: 'largest_TemperatureRange',
			SMALLEST_TEMPERATURE_RANGE: 'smallest_TemperatureRange',
			HIGHEST_RAINFALL: 'highest_Rainfall',
			HIGHEST_HOURLY_RAINFALL: 'highest_HighHourlyRain',
			HIGHEST_RAIN_RATE: 'highest_HighRainRate',
			HIGHEST_WIND_GUST: 'highest_HighWindGust',
			HIGHEST_WIND_RUN: 'highest_WindRun',
			HIGHEST_PRESSURE: 'highest_HighPressure',
			LOWEST_PRESSURE: 'lowest_LowPressure',
			HIGHEST_DEWPOINT: 'highest_HighDewpoint',
			LOWEST_DEWPOINT: 'lowest_LowDewpoint',
			LOWEST_HUMIDITY: 'lowest_LowHumidity'
		};

		_this.state = {
			activeParameterId: _this.PARAMETER_ID.HIGHEST_HIGH_TEMPERATURE
		};

		_this.parameters = getParametersData(_this.PARAMETER_ID, units, _this.formatters);

		_this.onParameterListClick = _this.onParameterListClick.bind(_this);
		_this.onParameterListKeyPress = _this.onParameterListKeyPress.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	RecordsTopTen.prototype.changeParameter = function changeParameter(id) {
		this.setState({ activeParameterId: id });
	};

	RecordsTopTen.prototype.onParameterListClick = function onParameterListClick(evt) {
		if (evt.target.hasAttribute('data-id')) {
			var id = evt.target.getAttribute('data-id');

			if (id !== this.state.activeParameterId) {
				this.changeParameter(id);
			}
		}
	};

	RecordsTopTen.prototype.onParameterListKeyPress = function onParameterListKeyPress(evt) {
		if (evt.keyCode === 13) {
			this.onParameterListClick(evt);
		}
	};

	RecordsTopTen.prototype.onOptionSelect = function onOptionSelect(opt) {
		this.changeParameter(opt.value);
	};

	RecordsTopTen.prototype.renderParametersList = function renderParametersList() {
		var _this2 = this;

		return Object(preact_min["h"])(
			'ul',
			{ 'class': records_top_ten_style_default.a.parameters_list, onClick: this.onParameterListClick, onKeyPress: this.onParameterListKeyPress },
			this.parameters.map(function (param) {
				var cssClass = param.id === _this2.state.activeParameterId ? records_top_ten_style_default.a.active : null;

				return Object(preact_min["h"])(
					'li',
					{ tabIndex: '0', 'class': cssClass, key: param.id, 'data-id': param.id },
					param.label
				);
			})
		);
	};

	RecordsTopTen.prototype.renderSelector = function renderSelector() {
		var options = this.parameters.map(function (param) {
			return { value: param.id, label: param.label };
		});

		return Object(preact_min["h"])(selector["a" /* default */], { options: options,
			selectedValue: this.state.activeParameterId,
			onOptionSelect: this.onOptionSelect });
	};

	RecordsTopTen.prototype.renderTable = function renderTable(data, paramData) {
		var _this3 = this;

		var extraColumns = Array.isArray(paramData.additionalColumns) ? paramData.additionalColumns : [];

		return Object(preact_min["h"])(
			'div',
			{ role: 'table', 'class': records_top_ten_style_default.a.table },
			Object(preact_min["h"])(
				'div',
				{ role: 'rowgroup' },
				Object(preact_min["h"])(
					'div',
					{ role: 'row' },
					records_top_ten__ref,
					Object(preact_min["h"])(
						'div',
						{ role: 'columnheader' },
						'Value (',
						paramData.unit,
						')'
					),
					extraColumns.map(function (column) {
						return Object(preact_min["h"])(
							'div',
							{ role: 'columnheader' },
							column.label
						);
					}),
					records_top_ten__ref2
				)
			),
			Object(preact_min["h"])(
				'div',
				{ role: 'rowgroup' },
				data.map(function (d, i) {
					var value = d[paramData.field];
					var formattedValue = paramData.formatter(value);
					return Object(preact_min["h"])(
						'div',
						{ key: i, role: 'row' },
						Object(preact_min["h"])(
							'div',
							{ role: 'cell' },
							i + 1
						),
						Object(preact_min["h"])(
							'div',
							{ role: 'cell' },
							formattedValue
						),
						extraColumns.map(function (column) {
							var columnValue = d[column.field];
							var formattedColumnValue = column.formatter(columnValue);
							return Object(preact_min["h"])(
								'div',
								{ role: 'cell' },
								formattedColumnValue
							);
						}),
						Object(preact_min["h"])(
							'div',
							{ role: 'cell' },
							Object(preact_min["h"])(
								preact_router_es["Link"],
								{ href: '/history-daily/' + d.date },
								_this3.formatters.date(d.date)
							)
						)
					);
				})
			)
		);
	};

	RecordsTopTen.prototype.render = function render(props) {
		var _this4 = this;

		var paramData = this.parameters.filter(function (p) {
			return p.id === _this4.state.activeParameterId;
		})[0];
		var data = this.props.data[this.state.activeParameterId];

		return Object(preact_min["h"])(
			'div',
			{ 'class': records_top_ten_style_default.a.records_top_ten },
			Object(preact_min["h"])(
				'div',
				{ 'class': records_top_ten_style_default.a.parameters_wrapper },
				props.windowWidth < 600 ? this.renderSelector() : this.renderParametersList()
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': records_top_ten_style_default.a.table_wrapper },
				Object(preact_min["h"])(
					'h3',
					{ 'class': records_top_ten_style_default.a.table_title },
					paramData.label
				),
				Object(preact_min["h"])(
					'p',
					{ 'class': records_top_ten_style_default.a.table_description },
					paramData.description
				),
				this.renderTable(data, paramData)
			)
		);
	};

	return RecordsTopTen;
}(preact_min["Component"]);

/* harmony default export */ var records_top_ten = (Object(handle_loading_and_error["a" /* default */])(Object(size_aware["a" /* default */])(records_top_ten_RecordsTopTen)));
// EXTERNAL MODULE: ./utils/object-helpers.js
var object_helpers = __webpack_require__("o4Fd");

// EXTERNAL MODULE: ./utils/date-utils.js
var date_utils = __webpack_require__("Z83D");

// EXTERNAL MODULE: ./components/records-monthly/style.scss
var records_monthly_style = __webpack_require__("lzjs");
var records_monthly_style_default = /*#__PURE__*/__webpack_require__.n(records_monthly_style);

// CONCATENATED MODULE: ./components/records-monthly/index.js


function records_monthly__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function records_monthly__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function records_monthly__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













/**
 * The RecordsMonthly component is a view displayed on the History records page.
 * It displays a records table along with a month selector which allows users to see
 * records for each calendar month of the year.
 *
 * props:
 * - month: the current month number
 * - data: full data set of monthly records data
 */

var records_monthly_RecordsMonthly = function (_Component) {
	records_monthly__inherits(RecordsMonthly, _Component);

	function RecordsMonthly() {
		records_monthly__classCallCheck(this, RecordsMonthly);

		return records_monthly__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	RecordsMonthly.prototype.onMonthSelected = function onMonthSelected(option) {
		Object(preact_router_es["route"])('/history-records/monthly/' + option.routeSubview);
	};

	RecordsMonthly.prototype.renderTabs = function renderTabs() {
		var options = Object(date_utils["a" /* getMonthNames */])().map(function (month, i) {
			return {
				id: i + 1,
				label: month.slice(0, 3),
				routeSubview: month.toLowerCase()
			};
		});

		return Object(preact_min["h"])(tabs["a" /* default */], { options: options,
			selectedId: this.props.month,
			tabSelected: this.onMonthSelected,
			isSecondary: true });
	};

	RecordsMonthly.prototype.renderSelector = function renderSelector() {
		var options = Object(date_utils["a" /* getMonthNames */])().map(function (month, i) {
			return {
				value: i + 1,
				label: month,
				routeSubview: month.toLowerCase()
			};
		});

		return Object(preact_min["h"])(selector["a" /* default */], { options: options,
			selectedValue: this.props.month,
			onOptionSelect: this.onMonthSelected });
	};

	RecordsMonthly.prototype.render = function render(props) {
		if (props.month === null) {
			return null;
		}

		var data = Object(object_helpers["c" /* mapObj */])(props.data, function (param, items) {
			return items.filter(function (item) {
				return item.month === props.month;
			})[0];
		});

		return Object(preact_min["h"])(
			'div',
			{ 'class': records_monthly_style_default.a.monthly_records },
			Object(preact_min["h"])(
				'div',
				{ 'class': records_monthly_style_default.a.monthly_selector_wrapper },
				props.windowWidth < 600 ? this.renderSelector() : this.renderTabs()
			),
			Object(preact_min["h"])(records_table, { data: data, isMonthly: true })
		);
	};

	return RecordsMonthly;
}(preact_min["Component"]);

/* harmony default export */ var records_monthly = (Object(handle_loading_and_error["a" /* default */])(Object(size_aware["a" /* default */])(records_monthly_RecordsMonthly)));
// EXTERNAL MODULE: ./components/card/index.js
var card = __webpack_require__("MTo3");

// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__("/R+W");

// EXTERNAL MODULE: ./components/page-title/index.js
var page_title = __webpack_require__("O7V0");

// EXTERNAL MODULE: ./routes/history-records/style.scss
var history_records_style = __webpack_require__("7D7g");
var history_records_style_default = /*#__PURE__*/__webpack_require__.n(history_records_style);

// CONCATENATED MODULE: ../node_modules/babel-loader/lib??ref--0!./routes/history-records/index.js


function history_records__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function history_records__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function history_records__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var history_records__ref = Object(preact_min["h"])(
	page_title["a" /* default */],
	null,
	'Weather Station Records'
);

var history_records__ref2 = Object(preact_min["h"])(
	'strong',
	null,
	'Data period:'
);

var history_records_HistoryRecordsPage = function (_Component) {
	history_records__inherits(HistoryRecordsPage, _Component);

	function HistoryRecordsPage(props, context) {
		history_records__classCallCheck(this, HistoryRecordsPage);

		var _this = history_records__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.VIEW_ID = {
			OVERALL: 'overall',
			TOP_TEN: 'top10',
			MONTHLY: 'monthly'
		};

		_this.views = [{
			id: _this.VIEW_ID.OVERALL,
			routeView: 'overall',
			label: 'Overall'
		}, {
			id: _this.VIEW_ID.TOP_TEN,
			routeView: 'top-ten',
			label: 'Top 10'
		}, {
			id: _this.VIEW_ID.MONTHLY,
			routeView: 'monthly',
			label: 'Monthly'
		}];

		_this.state = {
			activeViewId: null,
			records: undefined,
			recordsLoading: false,
			recordsRetryCount: -1
		};

		_this.loadRecords = _this.loadRecords.bind(_this);

		_this.requestAbort = {
			records: null
		};
		return _this;
	}

	HistoryRecordsPage.prototype.navigate = function navigate(viewData) {
		Object(preact_router_es["route"])('/history-records/' + viewData.routeView);
	};

	HistoryRecordsPage.prototype.setViewFromRoute = function setViewFromRoute(routeView, routeSubview) {
		var viewData = this.views.filter(function (v) {
			return v.routeView === routeView;
		})[0];

		var isValidView = viewData !== undefined;
		var isValidSubview = void 0;

		if (viewData && viewData.id === this.VIEW_ID.MONTHLY) {

			// Monthly records page has subview - the month names or empty string (default to current month)
			var validSubviews = Object(date_utils["a" /* getMonthNames */])().map(function (month) {
				return month.toLowerCase();
			});
			isValidSubview = routeSubview === '' || validSubviews.indexOf(routeSubview) !== -1;
		} else {

			// Other records pages have no subviews - make sure none is set
			isValidSubview = routeSubview === '';
		}

		var isValid = isValidView && isValidSubview;

		if (isValid) {
			this.setState({ activeViewId: viewData.id });

			this.context.titleService.update(viewData.label + ' Records');
			this.context.tracking.recordPageView();
		} else {
			Object(preact_router_es["route"])('/not-found', true);
		}

		return isValid;
	};

	HistoryRecordsPage.prototype.loadRecords = function loadRecords() {
		var _this2 = this;

		this.setState({
			recordsLoading: true
		});

		var request = Object(api["n" /* fetchRecords */])();
		this.requestAbort.records = request.abort;

		request.promise.then(function (res) {
			_this2.setState({
				records: res.data,
				recordsLoading: false,
				recordsRetryCount: -1
			});
		}).catch(function (err) {
			if (err.name !== api["a" /* ABORT_ERROR_NAME */]) {
				_this2.setState(function (state) {
					return {
						records: null,
						recordsLoading: false,
						recordsRetryCount: state.recordsRetryCount + 1
					};
				});
				_this2.context.tracking.recordException('Error loading records data', err);
			}
		});
	};

	HistoryRecordsPage.prototype.componentDidMount = function componentDidMount() {
		var isValidRoute = this.setViewFromRoute(this.props.view, this.props.subview);

		if (isValidRoute) {
			this.loadRecords();
		}
	};

	HistoryRecordsPage.prototype.componentWillUnmount = function componentWillUnmount() {
		Object(api["b" /* abortRequests */])(this.requestAbort);
	};

	HistoryRecordsPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.view !== this.props.view || nextProps.subview !== this.props.subview) {
			this.setViewFromRoute(nextProps.view, nextProps.subview);
		}
	};

	HistoryRecordsPage.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
		return this.state !== nextState;
	};

	HistoryRecordsPage.prototype.renderContent = function renderContent() {
		switch (this.state.activeViewId) {

			case this.VIEW_ID.OVERALL:
				return this.renderOverall();

			case this.VIEW_ID.TOP_TEN:
				return this.renderTopTen();

			case this.VIEW_ID.MONTHLY:
				return this.renderMonthly();
		}
	};

	HistoryRecordsPage.prototype.renderOverall = function renderOverall() {
		var data = this.state.records ? this.state.records.overall : this.state.records;

		return Object(preact_min["h"])(records_overall, { data: data,
			isLoading: this.state.recordsLoading,
			errorMessage: 'Unable to load records data',
			retryCount: this.state.recordsRetryCount,
			retryHandler: this.loadRecords });
	};

	HistoryRecordsPage.prototype.renderTopTen = function renderTopTen() {
		var data = this.state.records ? this.state.records.top10 : this.state.records;

		return Object(preact_min["h"])(records_top_ten, { data: data,
			isLoading: this.state.recordsLoading,
			errorMessage: 'Unable to load records data',
			retryCount: this.state.recordsRetryCount,
			retryHandler: this.loadRecords });
	};

	HistoryRecordsPage.prototype.renderMonthly = function renderMonthly() {
		var data = this.state.records ? this.state.records.monthly : this.state.records;

		var month = void 0;

		if (this.props.subview !== '') {
			month = Object(date_utils["a" /* getMonthNames */])().map(function (month) {
				return month.toLowerCase();
			}).indexOf(this.props.subview) + 1;
		} else {
			month = this.state.records ? new Date(this.state.records.end).getMonth() + 1 : null;
		}

		return Object(preact_min["h"])(records_monthly, { data: data,
			month: month,
			isLoading: this.state.recordsLoading,
			errorMessage: 'Unable to load records data',
			retryCount: this.state.recordsRetryCount,
			retryHandler: this.loadRecords });
	};

	HistoryRecordsPage.prototype.render = function render() {
		var dataPeriod = '---';

		if (this.state.records) {
			var transformDate = Object(utils_formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d', '%-d %b %Y');
			dataPeriod = transformDate(this.state.records.start) + ' - ' + transformDate(this.state.records.end);
		}

		return Object(preact_min["h"])(
			'div',
			null,
			history_records__ref,
			Object(preact_min["h"])(tabs["a" /* default */], { options: this.views, selectedId: this.state.activeViewId, tabSelected: this.navigate }),
			Object(preact_min["h"])(
				card["a" /* default */],
				{ noMargin: true },
				this.renderContent(),
				Object(preact_min["h"])(
					'p',
					{ 'class': history_records_style_default.a.data_period },
					history_records__ref2,
					' ',
					dataPeriod
				)
			)
		);
	};

	return HistoryRecordsPage;
}(preact_min["Component"]);

/* harmony default export */ var history_records = __webpack_exports__["default"] = (history_records_HistoryRecordsPage);

/***/ }),

/***/ "7D7g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"data_period":"data_period__2lboK"};

/***/ }),

/***/ "g7QX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"records_top_ten":"records_top_ten__3QvZL","parameters_wrapper":"parameters_wrapper__3t0mR","parameters_list":"parameters_list__2XFKz","active":"active__1e8jQ","table_wrapper":"table_wrapper__1h4gM","table_title":"table_title__3-qVf","table_description":"table_description__2Q0tN","table":"table__3q3rV"};

/***/ }),

/***/ "ki89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("r1QN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The Tabs component displays a series of tabs in a row. Note that the tabs
 * do not wrap, so make sure that not too many are used as they will not fit
 * on a small screen.
 *
 * props:
 * - options: array of data objects, one for each tab. { id: any, label: string }[]
 * - selectedId: the id of the selected tab (should match one of the ids in props.options)
 * - tabSelected: function called when the user selects a non-active tab
 * - isSecondary: true if the secondary, smaller, flat version of tabs is desired, e.g. for use within a card
 */

var Tabs = function (_Component) {
	_inherits(Tabs, _Component);

	function Tabs(props) {
		_classCallCheck(this, Tabs);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.onTabClick = _this.onTabClick.bind(_this);
		_this.onTabKeyPress = _this.onTabKeyPress.bind(_this);
		return _this;
	}

	Tabs.prototype.onTabClick = function onTabClick(evt) {
		if (evt.target.hasAttribute('data-index')) {

			var index = Number(evt.target.getAttribute('data-index'));

			var option = this.props.options[index];

			if (option.id !== this.props.selectedId) {
				this.props.tabSelected(option);
			}
		}
	};

	Tabs.prototype.onTabKeyPress = function onTabKeyPress(evt) {
		if (evt.keyCode === 13) {
			this.onTabClick(evt);
		}
	};

	Tabs.prototype.render = function render(props) {
		var cssClasses = [__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.tabs];

		if (props.isSecondary) {
			cssClasses.push(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.secondary);
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'ul',
			{ 'class': cssClasses.join(' '), onClick: this.onTabClick, onKeyPress: this.onTabKeyPress },
			props.options.map(function (opt, i) {
				var cssClasses = [__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.tab];

				if (opt.id === props.selectedId) {
					cssClasses.push(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.tab_active);
				}

				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'li',
					{ tabIndex: '0', key: opt.id, 'data-index': i, 'class': cssClasses.join(' ') },
					opt.label
				);
			})
		);
	};

	return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),

/***/ "lzjs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"monthly_records":"monthly_records__3yuPF","monthly_selector_wrapper":"monthly_selector_wrapper__3VG--"};

/***/ }),

/***/ "r1QN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tabs":"tabs__1n7Vv","secondary":"secondary__3WhTs","tab":"tab__3Gnm_","tab_active":"tab_active__2RYgO"};

/***/ }),

/***/ "wzQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"records_table":"records_table__1U3mu","row":"row__1dGCh","column_headings":"column_headings__UTRs7","label_cell":"label_cell__1zgVs","value_cell":"value_cell__2xuni","datetime_cell":"datetime_cell__HUrSh","date":"date__3Em8D","time":"time__2HkKb"};

/***/ })

});


// WEBPACK FOOTER //
// route-history-records.chunk.2f556.js